import React, { Component } from 'react'
import { FormattedMessage, injectIntl } from 'react-intl'
import { getEventName } from '../../../name-helpers/eventNameHelper'
import { capitalize } from '../../../name-helpers/nameFormatter'

class CalendarEventCreated extends Component {

    render() {
        return <div className={"row " + this.props.className}>
            <div className="col-12">
                <FormattedMessage
                    id="calendar_event.analytics.events.calendar_event_created"
                    defaultMessage="Calendar {eventName} {identifier} has been created"
                    values={{
                        identifier: this.props.object.attributes.identifier,
                        eventName: capitalize(getEventName(this.props.intl))
                    }}
                />
            </div>
        </div>
    }

}

export default injectIntl(CalendarEventCreated)





// WEBPACK FOOTER //
// ./src/quote/analytics/events/calendar-event-created.component.jsx